import React, { Dispatch, SetStateAction } from 'react';
import { Box, Link, Text } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import { DiscountType } from 'commons/types';
import { useTranslationWithPrefix } from 'commons/utils';
import BankTransferDiscount from './BankTransferDiscount/BankTransferDiscount';

interface BankTransferContentProps {
  discounts: DiscountType[];
  setDiscounts: Dispatch<SetStateAction<DiscountType[]>>;
  setDiscountChanged: Dispatch<SetStateAction<boolean>>;
  enabled: boolean;
  hasActivePromotions: boolean;
}

function BankTransferContent({
  discounts,
  setDiscounts,
  setDiscountChanged,
  enabled,
  hasActivePromotions,
}: BankTransferContentProps): JSX.Element {
  const { t } = useTranslationWithPrefix('paymentMethods');

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Box display="flex" flexDirection="column">
        <Text>{t('transferDescription')}</Text>
        <Link
          as="a"
          href={t('knowMoreLink')}
          target="_blank"
          appearance="neutral"
        >
          {t('knowMore')}
          <ExternalLinkIcon size="small" />
        </Link>
      </Box>
      {enabled && (
        <BankTransferDiscount
          discounts={discounts}
          setDiscounts={setDiscounts}
          setDiscountChanged={setDiscountChanged}
          hasActivePromotions={hasActivePromotions}
        />
      )}
    </Box>
  );
}

export default BankTransferContent;
